import { omit } from "lodash";
import moment from "moment-timezone";
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { Header, Icon } from "semantic-ui-react";

import { MODIFIED_AT_TIME_FORMAT } from "../config.js";

class ExpiryHeader extends Component {
  static propTypes = {
    invite: PropTypes.object.isRequired,
    copy: PropTypes.object.isRequired
  };

  getCopy = hasExpired => {
    const { copy } = this.props;
    return hasExpired ? copy.expired : copy.expires;
  };

  getColors = hasExpired => {
    return {
      icon: hasExpired ? "red" : "orange",
      text: hasExpired ? "red" : "grey"
    };
  };

  // -- RENDER -- //

  render = () => {
    const {
      invite: { expiredAt }
    } = this.props;

    const expiresTime = moment(expiredAt);

    const hasExpired = moment().isSameOrAfter(expiresTime);

    const colors = this.getColors(hasExpired);

    // pass through props
    const headerProps = omit(this.props, "invite", "copy");

    return (
      <Header {...headerProps} color={hasExpired ? "red" : "grey"}>
        <Icon name="exclamation circle" color={colors.icon} size="large" />
        <Header.Content color={colors.icon}>
          {`${this.getCopy(hasExpired)}: ${expiresTime.format(
            MODIFIED_AT_TIME_FORMAT
          )}`}
        </Header.Content>
      </Header>
    );
  };
}

export default ExpiryHeader;
